module.exports = __webpack_public_path__ + "static/img/cdjcxy.51e17b88.png";